const ja = {
  translation: {
    // Navigation
    'home': 'ホーム',
    'about_us': '私たちについて',
    'services': 'サービス',
    'contact': 'お問い合わせ',
    'locations': '拠点',

    // Home page content
    'hero_title': '航空会社クルー向けプレミアム送迎サービス',
    'hero_title_first_line': '航空会社クルー向け',
    'hero_title_second_line': 'プレミアム送迎サービス',
    'hero_subtitle': 'サンフランシスコ、ロサンゼルス、シリコンバレー、フロリダ、ニューヨーク、テキサス、オーストラリアのシドニーで№1の送迎サービスプロバイダーです。',
    'hero_cta_first_line': '航空クルー送迎',
    'hero_cta_second_line': 'コンシェルジュに',
    'hero_cta_third_line': 'お問い合わせ',
    'hero_cta': '航空クルー送迎コンシェルジュにお問い合わせ',

    // About section
    'about_title': '私たちについて',
    'about_description': '北米をリードする航空クルー＆ホテルシャトルサービスプロバイダーです。30年近くにわたり、世界中の航空会社クルーに信頼性の高い、安全で効率的な輸送ソリューションを提供してきました。',
    'about_years': '卓越した実績の年数',
    'about_global_locations': 'グローバル拠点',
    'about_service': 'サービス＆サポート',
    'get_in_touch': '航空クルー送迎コンシェルジュにお問い合わせ',
    'about_second_paragraph': '私たちの卓越性、時間厳守、顧客満足度へのこだわりにより、多くの国際航空会社から選ばれています。フライトクルーの特別なニーズを理解し、送迎からドロップオフまで快適でストレスのない体験を提供するサービスを提供しています。',

    // In Good Company section
    'in_good_company_title': '信頼のパートナー',
    'in_good_company_description': '世界をリードする航空会社から信頼されている信頼性の高いプレミアム送迎サービス。',

    // Testimonials section
    'testimonials_title': 'お客様の声',
    'testimonials_description': '主要航空会社やクライアントが私たちの送迎サービスを選ぶ理由をご覧ください。',

    // Testimonial quotes
    'testimonial_1_quote': 'エアラインクルートランスポーテーションのマネージャーと、フライトクルーの夏のスケジュールについて仕事をしてまとめる時間は素晴らしい体験でした。',
    'testimonial_1_author': 'SAS航空',
    'testimonial_1_company': 'ステーションマネージャー',

    'testimonial_2_quote': '私たちはついに宝石を見つけました。',
    'testimonial_2_author': 'Aish Wedding Services',
    'testimonial_2_company': 'CEOおよびマネージャー',

    'testimonial_3_quote': 'エアラインクルートランスポーテーションがフライトクルーとキャビンクルーのホテルへの送迎を担当すると聞いて、一つ心配事が減って安心しました。',
    'testimonial_3_author': 'エルアル航空',
    'testimonial_3_company': 'ステーションマネージャー',

    // Services section
    'services_title': '私たちのサービス',
    'services_description': '快適さと信頼性を兼ね備えた、お客様の特定のニーズに合わせて設計された当社のプレミアム送迎オプションをご覧ください。',
    'select_a_service': 'サービスを選択',
    'get_a_quote': 'お見積り依頼',

    // Service items
    'service_airport_transfer_title': '空港送迎',
    'service_airport_transfer_bullet1': '時間厳守の送迎でスムーズな運営を実現。',
    'service_airport_transfer_bullet2': '清潔で設備の整った車両で快適な移動を提供。',

    'service_distressed_passengers_title': 'ディストレストパッセンジャー送迎',
    'service_distressed_passengers_bullet1': 'フライト遅延・欠航に24時間365日迅速対応。',
    'service_distressed_passengers_bullet2': 'ホテルや代替空港への効率的な移動手配。',

    'service_any_occasion_title': 'あらゆる機会に対応する車両サービス',
    'service_any_occasion_bullet1': '企業イベントや会議向けプレミアム送迎サービス。',
    'service_any_occasion_bullet2': 'エグゼクティブが万全の状態で到着できるプロサービス。',

    'service_hotel_transfer_title': 'ホテル送迎',
    'service_hotel_transfer_bullet1': '宿泊施設と空港間のシームレスな連携。',
    'service_hotel_transfer_bullet2': '早朝出発・深夜到着に完璧なタイミング調整。',

    'service_flight_cabin_crew_title': 'フライト＆キャビンクルーシャトル',
    'service_flight_cabin_crew_bullet1': '航空運用要件を理解した専門サービス。',
    'service_flight_cabin_crew_bullet2': 'クルースケジュールのタイミングプロトコルを厳守。',

    'service_company_shuttle_title': '企業シャトルサービス',
    'service_company_shuttle_bullet1': '従業員・役員向けカスタマイズ送迎ソリューション。',
    'service_company_shuttle_bullet2': 'リアルタイム追跡とコスト効率を備えた定期ルート。',

    'service_charter_services_title': 'チャーターサービス',
    'service_charter_services_bullet1': 'あらゆる規模のグループ向けオーダーメイド送迎ソリューション。',
    'service_charter_services_bullet2': 'カスタム車両オプション付きプロ物流計画。',

    // Fleet section
    'fleet_title': '私たちの車両',
    'fleet_description': '送迎ニーズすべてに卓越した快適性、スタイル、信頼性を提供するために選ばれた、多様な高級車両をご覧ください。',
    'select_a_vehicle': '車両を選択',

    // Fleet items
    'fleet_sedan_title': 'セダン',
    'fleet_sedan_description': 'プロのドライバーによるエグゼクティブ向け高級セダン。最大3席。',

    'fleet_suv_title': 'SUV',
    'fleet_suv_description': '小グループに広々とした快適さを提供するプレミアムSUV。最大6席。',

    'fleet_sprinter_title': 'スプリンター',
    'fleet_sprinter_description': '中規模グループ向けの高級設備を備えたメルセデス・ベンツスプリンターバン。最大14席。',

    'fleet_minibus_title': 'ミニバス',
    'fleet_minibus_description': '十分な荷物スペースを備えた大規模グループ向けの快適なミニバス。最大27席。',

    'fleet_mini_coach_title': 'ミニコーチ',
    'fleet_mini_coach_description': '中〜大規模グループにプレミアム輸送を提供するミニコーチ。最大35席。',

    'fleet_coach_title': 'コーチ',
    'fleet_coach_description': '大規模グループ輸送ニーズ向けのフルサイズ高級コーチ。最大55席。',

    // Fleet vehicle details (for carousel)
    'fleet_van_title': 'バン',
    'fleet_van_capacity': '乗客定員 1-3名',
    'fleet_van_description': '当社のエグゼクティブバンは、個人の乗務員や小規模チームを輸送するための快適で効率的なソリューションを提供します。\n\n広々とした内装、プロのドライバー、信頼できるスケジューリングにより、これらの車両は早朝出発、深夜到着、その間のすべてに最適です。',

    'fleet_sprinter_carousel_title': 'スプリンター',
    'fleet_sprinter_carousel_capacity': '乗客定員 1-14名',
    'fleet_sprinter_carousel_description': '当社のメルセデススプリンターバンは、十分な荷物スペースを持つ中規模グループにプレミアムな快適さを提供します。\n\n高級シート、気候制御、プロの運転手を備えており、これらの車両は乗務員の移送やグループ輸送のニーズに理想的です。',

    'fleet_minivan_title': 'ミニバン',
    'fleet_minivan_capacity': '乗客定員 1-7名',
    'fleet_minivan_description': '当社の快適なミニバンは、信頼できる効率的な輸送を必要とする小〜中規模の乗務員グループに最適です。\n\n柔軟なシート配置と大容量の荷物スペースにより、これらの車両は航空乗務員のニーズに快適性と実用性の完璧なバランスを提供します。',

    'fleet_minibus_carousel_title': 'ミニバス',
    'fleet_minibus_carousel_capacity': '乗客定員 1-25名',
    'fleet_minibus_carousel_description': '当社の広々としたミニバスは、より大きな乗務員グループ向けに設計されており、快適なシートと十分な荷物収納を提供します。\n\nエアコン、リクライニングシート、スムーズな乗り心地により、これらの車両は乗務員がリフレッシュした状態で到着し、任務に備えることを保証します。',

    'fleet_minicoach_title': 'ミニコーチ',
    'fleet_minicoach_capacity': '乗客定員 1-35名',
    'fleet_minicoach_description': '当社のプレミアムミニコーチは、最大限の快適性とスタイルで大規模な乗務員グループに高級輸送を提供します。\n\n豪華なシート、エンターテインメントシステム、気候制御を備えており、これらのコーチは最も重要な乗務員移送にファーストクラスの旅行体験を提供します。',

    // Passenger capacity
    'passenger_capacity': '乗車定員',
    'seats': '席',

    // How We Work section
    'how_we_work_title': '私たちの働き方',
    'how_we_work_description': '私たちの卓越性へのコミットメントは、サービス品質を推進する3つの中核原則に基づいています。',
    'how_we_work_card1_title': '人を第一に',
    'how_we_work_card1_description': '私たちには小さすぎる、大きすぎる、複雑すぎる仕事はありません。1〜2名のクライアントから35名のクルーメンバーまで、私たちを頼りにしていただけます。',
    'how_we_work_card2_title': 'プロフェッショナルドライバー',
    'how_we_work_card2_description': '当社のドライバーは専門的な資格を持ち、ルートを熟知し、可能な限り安全に車両を運転し、常に高水準と礼儀正しさでお客様に接します。',
    'how_we_work_card3_title': 'リアルタイム更新',
    'how_we_work_card3_description': 'エアラインクルートランスポーテーションは、ドライバーとバスの日々の配車を管理するための効率的な集中配車センターを確立しました。すべての乗客の安全を確保するため、リアルタイムGPSが導入されています。',

    // Contact section
    'contact_title': 'お問い合わせ',
    'contact_name': '氏名',
    'contact_name_placeholder': 'お名前',
    'contact_name_required': '氏名は必須です',
    'contact_email': 'メール',
    'contact_email_placeholder': 'your@email.com',
    'contact_email_required': 'メールは必須です',
    'contact_email_invalid': '有効なメールアドレスを入力してください',
    'contact_phone': '電話番号',
    'contact_phone_placeholder': '電話番号',
    'contact_subject': '件名',
    'contact_subject_placeholder': '件名',
    'contact_subject_required': '件名は必須です',
    'contact_message': 'メッセージ',
    'contact_message_placeholder': 'メッセージ',
    'contact_message_required': 'メッセージは必須です',
    'contact_submit': '送信',
    'contact_sending': '送信中...',
    'contact_success': 'メッセージが正常に送信されました！',
    'contact_thank_you': 'ありがとうございます！',
    'contact_success_message': 'メッセージが正常に送信されました。まもなくご連絡いたします。',
    'contact_send_another': '別のメッセージを送信',
    'contact_hours': '営業時間',
    'contact_24_7': '24時間365日カスタマーサービス',

    // Footer
    'footer_copyright': 'エアラインクルートランスポーテーション。All Rights Reserved.',

    // Locations page
    'locations_page_title': '拠点',
    'locations_page_subtitle': '世界中の主要都市でプレミアム送迎サービスを提供',

    // San Francisco location
    'location_sf_title': 'サンフランシスコ',
    'location_sf_description': '北カリフォルニアの文化、商業、金融の中心地。サンフランシスコは最も人気のある観光地の一つです。また、エアラインクルートランスポーテーションの本社があります。',

    // Silicon Valley location
    'location_sv_title': 'シリコンバレー',
    'location_sv_description': 'サンフランシスコベイエリアの南部に位置しています。世界最大のテクノロジー企業の多くの本拠地です。その中にはフォーチュン1000社、アドビ、イーベイ、アップル、グーグル、フェイスブック、テスラなどがあります。',

    // Miami location
    'location_miami_title': 'マイアミ',
    'location_miami_description': 'マイアミは一年中エキサイティングなエンターテイメント会場やアトラクションで賑わっています。エアラインクルートランスポーテーションはマイアミの主要ホテルや宿泊施設と強い協力関係を築いており、フライトクルー、ファーストクラス＆ビジネスクラスの乗客にマイアミ最高のアクセスを提供しています。',

    // Los Angeles location
    'location_la_title': 'ロサンゼルス',
    'location_la_description': 'ロサンゼルスはアメリカで2番目に大きい都市であり、カリフォルニア州で最も人口の多い都市です。エアラインクルートランスポーテーションの2番目の支店は、ロサンゼルスのLAX空港に便利に位置しています。',

    // New York City location
    'location_nyc_title': 'ニューヨーク',
    'location_nyc_description': 'ニューヨークは世界で最も写真に撮られる都市として評価されています。当社の例外的なサービスにより、長年にわたって当社に忠実であるハッピーな顧客のリストに、あなたの会社が加わることは喜ばしいことです。',

    // Fort Worth location
    'location_fw_title': 'フォートワース',
    'location_fw_description': 'フォートワースは広大な都市であり、エネルギーと独立した精神で活気づいています。現在、ダラスの主要な3つのホテルとビジネスを行っています。また、フォートワース空港で4つの主要航空会社のシャトルサービスも提供しています。',

    // Sydney location
    'location_sydney_title': 'シドニー、オーストラリア',
    'location_sydney_description': 'シドニーは象徴的な観光スポットと素晴らしいビーチがある、忘れられない目的地です。シドニーのエアラインクルートランスポーテーションは現在、主要航空会社のフライトおよびキャビンクルー向けシャトルサービスと、シドニーで最も名声あるホテルのシャトルプログラムを提供しています。',
  }
};

export default ja; 